export default __webpack_public_path__ + "slices/main/assets/public/media/ca_homepage.b89d9a4c28a4e7d83d540eb716e00362.png";